import { badgeEntityName } from '../../../../../backend/features/badges/shared';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import { Box, Card, Typography } from '@mui/material';
import React from 'react';
import { BadgeListItemActions } from './BadgeListItemActions';
import { BadgeListItemAnalytics } from './BadgeListItemAnalytics';
export const BadgeListItem = ({ badge, fetchBadgeList }) => {
    return (React.createElement(Card, { sx: { display: 'flex', p: 2, gap: { xs: 1, sm: 3 }, flexDirection: { xs: 'column', sm: 'row' } } },
        React.createElement(Box, { sx: {
                minWidth: '172px',
                maxWidth: { sm: '13%' },
                borderColor: themeColors.border.main,
                borderWidth: 1,
                borderStyle: 'solid',
                borderRadius: 1,
                overflow: 'hidden',
                aspectRatio: '172/112',
            } },
            React.createElement(Image, { entity: badgeEntityName, entityId: badge.id, attachmentKey: 'badgeFrontImage', sx: { width: '100%' } })),
        React.createElement(Box, { sx: { flex: 1, display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'space-between', minWidth: 0 } },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: { xs: 'column-reverse', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 1,
                } },
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0, width: '100%' } },
                    React.createElement(Typography, { variant: 'h6', noWrap: true }, badge.name),
                    React.createElement(Typography, { variant: 'body2', noWrap: true }, badge.description)),
                React.createElement(BadgeListItemActions, { badge: badge, fetchBadgeList: fetchBadgeList })),
            React.createElement(BadgeListItemAnalytics, { badge: badge }))));
};
